<template>
	<tr :class="{ 'table-info': candidateStock.editId == stock.id, 'table-success': candidateStock.saveId == stock.id }">

	<td>
		<strong style="max-width: 200px;">{{ stock.vendor?.shortForm ?? stock.vendor.name }}</strong>
		<span v-if="stock.vendor.id == 21"> (LZ: {{ stock.vendorDeliveryTime }})</span>
	</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td
		v-else-if="vendorCanEditArticleId(stock.vendor) && stock.id === candidateStock.editId"
		class="align-middle"
		style="max-width: 75px"
	>
		<div class="input-group input-group-sm">
			<input
				v-bind:id="'articleIdInput_' + candidateStock.editId"
				type="text"
				style="text-align: center; min-width: 75px"
				class="form-control"
				v-model="candidateStock.articleId"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
		</div>
	</td>
	<td v-else-if="stock.articleId" @click="editStock(stock, 'articleId')">{{stock.articleId}}</td>
	<td v-else @click="editStock(stock, 'articleId')">—</td>
	<td>
		<span v-if="stock.articleCondition == 1">N</span>
		<span v-else-if="stock.articleCondition == 2">SH</span>
		<span v-else>—</span>
	</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td
		v-else-if="stock.id == candidateStock.editId"
		class="align-middle"
		style="max-width: 75px"
	>
		<div class="input-group input-group-sm">
			<input
				v-bind:id="'purchasePriceInput_' + candidateStock.editId"
				type="text"
				style="text-align: left"
				class="form-control"
				v-model="candidateStock.purchasePrice"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
			<div class="input-group-append mb-auto">
				<span class="input-group-text">€</span>
			</div>
		</div>
	</td>
	<td v-else @click="editStock(stock)">
			<p class="top mb-0">{{ Number(stock.purchasePrice).toFixed(2) }} €</p>
	</td>
		<td id="column-eingangsporto">
			<span style="color:Gray">{{ calcVendorShippingFee(stock) }}€</span>
		</td>
		<td>
			<span style="color:Gray">{{ (Number(stock.vendor.incomeFine).toFixed(2)) }}€</span>
		</td>
		<td>
			<span style="color:Gray">{{ Number(stock.purchasePrice * (stock.vendor.deliverygroup.customs / 100)).toFixed(2) }}€
		</span></td>
	<td id="column-summe">{{ stock.sumPurchasePriceAndShippingFeeStr }}€</td>
	<td v-if="vendorCanEditArticleId(stock.vendor) && stock.id === stockSaveProcessing">
		<b-spinner style="width: 1rem; height: 1rem" label="loading..."/>
	</td>
	<td v-else-if="stock.id == candidateStock.editId" class="align-middle">
		<div class="input-group input-group-sm" style="width: 42px">
			<input
				v-bind:id="'quantityInput' + candidateStock.editId"
				type="text"
				style="text-align: center"
				class="form-control"
				v-model="candidateStock.quantity"
				@keypress.enter="stockSave(candidateStock.editId)"
			/>
		</div>
	</td>
	<td v-else @click="editStock(stock)">{{ stock.quantity }}</td>
	<td>
		LK <b>{{ stock.vendor.deliveryClass }}</b>
	</td>
<!--	<td>{{ stock.sku }}</td>-->
	<td v-if="candidateStock.editId == stock.id" style="height: 38px">
		<button
			type="button"
			class="btn btn-sm btn-primary pr-1"
			@click="stockSave(candidateStock.editId)"
		>
			<span class="icon icon-checkmark"></span>
		</button>
		<button
			type="button"
			class="btn btn-secondary btn-sm"
			@click="resetCandidateStock(stock.id)"
		>
			<span class="icon icon-cross"></span>
		</button>
	</td>
	<td v-else style="height: 38px">
		<b-spinner
			v-if="
				vendorCanEditArticleId(stock.vendor) &&
				stock.id === stockSaveProcessing
			"
			label="loading..."
		/>
		<div v-else-if="candidateStock.editId == null && (authorization.account_assistant || authorization.shipping_assistant)">
			<b-button-group>
				<button
					type="button"
					class="btn btn-secondary btn-sm pr-1"
					@click="editStock(stock)"
				>
					<span class="icon icon-pencil"></span>
				</button>
				<button
					type="button"
					class="btn btn-secondary btn-sm float-right"
					@click="emit_openManualVendorOrder(stock)"
				>
					<!-- button -->
					<span
						class="icon icon-cart"
						title="Manuelle Händlerbestellung"
					/>
				</button>
				<button
						type="button"
						class="btn btn-secondary btn-sm float-right"
						@click="emit_openVendorCancellation(stock)"
				>
					<!-- button -->
					<span
							class="icon bi-trash"
							title="Händlerstornierung"
					/>
				</button>
				<b-button
				:variant="stock.vendorStockBlock ? 'danger': 'secondary'"
				size="sm"
				v-if="(authorization.warehouse_manager ||  authorization.account_manager || userIsSevgi || userIsFlorian || userIsSebastian || userIsSvenja)"
        :disabled="disableVendorstockBlockButton"
				@click="emit_openVendorStockBlock">
					<i class="bi bi-dash-circle"></i>
				</b-button>
			</b-button-group>
		</div>
	</td>
		<modal-error-component v-model="modalError"></modal-error-component>
</tr>
</template>
<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
	props: ["stock", "stocks", "candidateStock", "authorization", "userName" ],
	data() {
		return {
			stockSaveProcessing: false,
			userIsSevgi : (this.userName && new String(this.userName.username).startsWith('Sevgi')),
			userIsSebastian : (this.userName && new String(this.userName.username).localeCompare('Sebastian Klupsch') === 0),
			userIsSvenja : (this.userName && new String(this.userName.username).localeCompare('Svenja Junker') === 0),
			userIsFlorian : (this.userName && new String(this.userName.username).localeCompare('Florian') === 0),
			modalError: {
				show: false,
				error: "",
				message:"",
				title: "Fehler beim Speichern der Lagerdaten",
			},
		}
	},
  computed:{
    disableVendorstockBlockButton(){
      if(this.authorization.master === false && this.authorization.manager === false && this.stock.vendor.hasVirtualStocks === 0)
      {return true;} else {return false;}
    },
	  checkIsNumber() {
		  return _.isNumber(this.stock?.ekGoal);
	  },
  },
	methods: {
		vendorCanEditArticleId: function (vendor) {
			const regexLagerPattern = new RegExp("^Lager[0-9]{1,}$|^Ausschussware( 7%)?$");
			return regexLagerPattern.test(vendor.name);
		},
		calcVendorShippingFee(stock){
			return Number(stock.vendorShippingFee - stock.vendor.incomeFine - (stock.purchasePrice * (stock.vendor.deliverygroup.customs / 100))).toFixed(2);
		},
		editStock(stock, field) {
			// do not copy stuff nor activate edit menu if we clicked on the articleId <td> and
			// the vendor isn't Lager 2 or 4 (i.e. is not in the vendorCanEdit liststock).
			if (field == "articleId" && !this.vendorCanEditArticleId(stock.vendor)) {
				return;
			}

			if (this.candidateStock.editId == null) {
				this.candidateStock.editId = stock.id;
				this.candidateStock.purchasePrice = Number(stock.purchasePrice).toFixed(2);
				this.candidateStock.quantity = stock.quantity;
				if (this.vendorCanEditArticleId(stock.vendor)) {
					this.candidateStock.articleId = stock.articleId;
				}
			}
		},
		stockSave() {
			let stock = this.stocks.find(
				(candidate) => candidate.id == this.candidateStock.editId
			);
			if (
				this.candidateStock.quantity == stock.quantity &&
				this.candidateStock.purchasePrice == stock.purchasePrice &&
				this.candidateStock.articleId == stock.articleId
			) {
				this.candidateStock.saveId = null;
				this.candidateStock.editId = null;
				return false;
			}
			this.candidateStock.saveId = this.candidateStock.editId;
			this.candidateStock.editId = null;
			let strippedStock = {
				id: stock.id,
				quantity:
					this.candidateStock.quantity != null
						? this.forceNumeric(this.candidateStock.quantity)
						: this.forceNumeric(stock.quantity),
				purchasePrice:
					this.candidateStock.purchasePrice != null
						? this.forceNumeric(this.candidateStock.purchasePrice)
						: this.forceNumeric(stock.purchasePrice),
			};
			this.candidateStock.purchasePrice = null;
			this.candidateStock.quantity = null;
			if (strippedStock.articleId !== null) {
				strippedStock.articleId = this.candidateStock.articleId;
			}
			this.stockSaveProcessing = strippedStock.id;
			axios
				.post("/stock/save", strippedStock)
				.then((response) => {
					// console.log(response);
					this.stockSaveProcessing = 0;
					stock.quantity = strippedStock.quantity;
					stock.purchasePrice = strippedStock.purchasePrice;
					if (strippedStock.articleId !== null) {
						stock.articleId = strippedStock.articleId;
					}
					this.stocks.sort((v, w) => {
						return Number(v.purchasePrice) - Number(w.purchasePrice);
					});
					this.candidateStock.editId = null;
					this.resetCandidateStock()
				})
				.catch((error) => {
					console.log(error);
					this.stockSaveProcessing = 0;
					this.modalError.error = error.toString();
					this.modalError.show = true;
					this.candidateStock.saveId = null;
					this.resetCandidateStock()
				});
		},
		forceNumeric(mangledNumber) {
			return Number(mangledNumber.toString().replace(',','.'));
		},
		truncateName(name) {
			return name.length > 15 ? name.substring(0, 15) + '...' : name;
		},
		resetCandidateStock(candidateId)
		{
			this.candidateStock.editId = null;
			this.candidateStock.quantity = null;
			this.candidateStock.purchasePrice = null;
			this.candidateStock.articleId = null;
		},
		emit_openManualVendorOrder() {
			this.$emit('openManualVendorOrder', this.stock);
		},
		emit_openVendorStockBlock() {
			this.$emit('openVendorStockBlock', this.stock);
		},
		emit_openVendorCancellation() {
			this.$emit('openVendorCancellation', this.stock);
		},
	}
}
</script>
